import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ToolTipIcon from "../../icons/toolTipIcon";
import "./ToolTip.scss";
class ToolTip extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const toolTipContent = _.map(_.get(this.props, "message"), (paragraph, index) => {
      return /* @__PURE__ */ jsx("p", { children: paragraph }, `${paragraph.length}-${index}`);
    });
    return /* @__PURE__ */ jsxs("div", { className: "tooltip-container", children: [
      /* @__PURE__ */ jsx("a", { "data-tip": true, "data-for": "toolTip", children: /* @__PURE__ */ jsx(ToolTipIcon, {}) }),
      /* @__PURE__ */ jsx(ReactTooltip, { className: "react-tool-tip", id: "toolTip", place: "right", type: "info", effect: "solid", children: /* @__PURE__ */ jsx("div", { children: toolTipContent }) })
    ] });
  }
}
ToolTip.propTypes = {
  message: PropTypes.array.isRequired
};
export default ToolTip;
